import { ContainerActions, ContainerState } from './types';
import ActionTypes from './constants';

export const isMobile = window.document.body.clientWidth < 768;

export const initialState: ContainerState = {
  loading: true,
  sections: {},
  loadingNote: false,
  userName: '',
  companyName: '',
  email: '',
  phoneNumber: '',
  isCheckingEmail: false,
  validationEmailMessage: '',
  submitting: false,
  isSuccess: false,
};

function farmToTableReducer(state: ContainerState = initialState, action: ContainerActions) {
  const { type, payload } = action as any;
  switch (type) {
    case ActionTypes.PRODUCTS_SOURCE_INIT:
      return { ...state, loading: true };
    case ActionTypes.PRODUCTS_SOURCE_REQUEST:
      return { ...state, sections: payload };
    case ActionTypes.PRODUCTS_SOURCE_SUCCESS:
    case ActionTypes.PRODUCTS_SOURCE_FAILURE:
      return { ...state, loading: false, sections: { ...state.sections, ...payload } };
    case ActionTypes.SET_PRODUCT_NOTE_REQUEST: {
      return { ...state, loadingNote: true };
    }

    case ActionTypes.SET_PRODUCT_NOTE_SUCCESS: {
      const { note, index, section } = payload;
      const products = [...state.sections[section].data];
      products[index] = { ...products[index], note: note };
      return {
        ...state,
        sections: { ...state.sections, [section]: { data: products, error: false } },
        loadingNote: false,
      };
    }
    case ActionTypes.SET_PRODUCT_NOTE_FAILURE: {
      return { ...state, loadingNote: false };
    }

    case ActionTypes.PRODUCTS_SOURCE_FAVORITE_SUCCESS: {
      const { index, section, isFavorite } = payload;
      const products = [...state.sections[section].data];
      products[index] = { ...products[index], isFavorite: isFavorite };
      return {
        ...state,
        sections: { ...state.sections, [section]: { data: products, error: false } },
      };
    }
    case ActionTypes.CHECK_EMAIL_REQUEST:
      return {
        ...state,
        isCheckingEmail: true,
        validationEmailMessage: '',
      };
    case ActionTypes.CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        isCheckingEmail: false,
        validationEmailMessage: '',
      };
    case ActionTypes.CHECK_EMAIL_FAILURE:
      return {
        ...state,
        isCheckingEmail: false,
        validationEmailMessage: payload,
      };
    case ActionTypes.CONTACT_US_SUBMIT:
      return {
        ...state,
        ...payload,
      };
    case ActionTypes.CONTACT_US_REQUEST: {
      return {
        ...state,
        ...payload,
        isSuccess: false,
        submitting: true,
      };
    }
    case ActionTypes.CONTACT_US_SUCCESS: {
      return {
        ...state,
        ...payload,
        isSuccess: true,
        submitting: false,
      };
    }
    case ActionTypes.CONTACT_US_FAILURE: {
      return {
        ...state,
        ...payload,
        isSuccess: false,
        submitting: false,
      };
    }
    default:
      return state;
  }
}

export default farmToTableReducer;
